const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Cobertura geográfica',
    description:
      'Cuando un propietario de vivienda busque instaladores de Enphase en un área en particular, usaremos la %{regionOrCountyLabel} que ingresaste para verificar si estás disponible para brindar servicio en esa área o no.',
    addNewArea: 'Añadir nueva área',
    new: 'Nuevo',
    areaName: 'Nombre de área',
    servicesCovered: {
      countiesCovered: 'Condados cubiertos',
      regionsCovered: 'Regiones cubiertas',
      provincesCovered: 'Provincias cubiertas',
      regionsWithCount: '%{region}(primeros %{typeCharacters} dígitos de códigos postales) cubiertas',
      districtsCovered: 'Distritos cubiertos',
      citiesCovered: 'Municipios cubiertas',
      citiesCoveredbr: 'Ciudades cubiertas',      
      departments: 'departamentos',
      regions: 'regiones',
      counties: 'condados',
      districts: 'distritos',
      cities: 'municipios',
      provinces: 'Provincias',
      city: 'ciudades'
    },
    selectAllCounty: 'Selecciona todas las %{regionOrCountyLabel} de un estado específico',
    selectAllCountyWithRegion: 'Selecciona todas las %{regionOrCountyLabel} De una Región Específica',
    selectAllDepartment: 'Seleccione todos los departamentos',
    addCountiesRegionsButton: 'Añadir %{regionOrCountyLabel}',
    countyButtonDescription:
      'En base a tu selección de Estado, se agregarán todos las %{regionOrCountyLabel} relacionadas',
    countyButtonDescriptionWithRegion: 'En base a tu selección de Region, se agregarán todos las %{regionOrCountyLabel} relacionadas',
    area1: 'ÁREA 1',
    selectState: 'Seleccionar estado',
    selectRegion: 'Seleccione región',
    requestNotProcessed: 'No se pudo procesar la solicitud',
    footerTitle:
      'El precio indicativo debería incluir costos de instalaciones, gabinetes, módulo fotovoltaico, inversor, etc. Costos tales como colocación de techos o actualización del panel principal pueden ser adicionales',
    footerBody:
      'Enphase proporcionará este precio indicativo al propietario de vivienda. Enphase proporcionará avisos legales al propietario de vivienda de que este precio es preliminar y está sujeto a cambios.',
    noBlankRegions: 'Las %{regionOrCountyLabel} cubiertas no pueden estar en blanco.',
    //noBlankCounties: 'Los condados cubiertos no pueden estar en blanco.',
    deleteConfirmation: '¿Seguro que deseas eliminar esta área de servicio?',
    ok: 'Aceptar',
    infoText: `%{bTagOpen}Region%{bTagClose} se define como los primeros %{count} dígitos de un código postal en %{stateOrProvince}`,
    infoTextFr: `El departamento se define por los dos primeros dígitos del código postal`,
    state: 'estado',
    province: 'provincia',
    noOptions: 'Sin opciones'
  }
};

export default serviceAreas;
